import { Text } from '@/components/text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LevelLabels } from './level-labels';
import { ProgressBarPrimitive } from './progress-bar-primitive';
import { View } from './tw-wrappers';

interface ProgressBarProps {
  label: string;
  value: number; // 0-100
  color?: string;
  backgroundColor?: string;
}

export const ProgressBar = ({
  label,
  value,
  color = '#FACC15',
  backgroundColor = '#E5E7EB',
}: ProgressBarProps) => {
  const { t } = useTranslation();

  return (
    <View className="w-full gap-1">
      <Text style={{ lineHeight: 12 }} className="text-[10px] text-gray-500">{label}</Text>

      <ProgressBarPrimitive
        value={value}
        color={color}
        backgroundColor={backgroundColor}
        height={10}
      />

      {/* Labels */}
      <LevelLabels />
    </View>
  );
};
